import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import nb from "../locales/nb-NO.json";

export const Language = {
  NB_NO: "nb-NO",
} as const;

export const availableLanguages: Language[] = Object.values(Language);

export type Language = (typeof Language)[keyof typeof Language];

const resources = {
  [Language.NB_NO]: { translation: nb },
};

i18next.use(initReactI18next).init({
  lng: Language.NB_NO,
  resources,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18next;
